@if (isRmbRmc) {
<div>
  <span>{{ staticText | globalTranslate }}</span>
</div>
} @if (isRmbRmc && this.selectedIndividual) {
<div><br /></div>
} @if (getValue('extras.topLevelAnswer') === 'YES') {
<div form-top>
  <p class="person-label">{{ selectedIndividual | fullname }}</p>
</div>
}<br />
<nh-form
  [topLevelName]="'or'"
  [formGroup]="getForm()"
  [mode]="mode"
  [individuals]="checkForDropdown ? finalListAll : individuals"
  (validate)="onValidate($event)"
  (individualAnswerChanged)="onIndividualChange($event)"
  class="label-section"
  individualQuestion="{{ 'OTHER_RESOURCES_INDIV_QUES' | globalTranslate }}"
  topLevelHintText="OTHER_RESOURCES_TOP_LEVEL_HINT"
  topLevelQuestion="{{ 'OTHER_RESOURCES_TOP_LEVEL' | globalTranslate }}"
  hintText="{{ hintText }}"
>
  <div (window:resize)="onResize($event)"></div>
  <section [formGroup]="getControl('data')">
    <h1 class="section-header">
      {{ "OTHER_RESOURCES_TITLE" | globalTranslate }}
    </h1>
    <hr />
    <nh-field
      id="or_assetType"
      label="{{ 'OTHER_RESOURCES_STATIC_TEXT1' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'VEHICLE_STATIC_TEXT3' | globalTranslate }} <div class=hint>{{
        'IF' | globalTranslate
      }} {{ selectedIndividual | fullname }} {{
        'OTHER_RESOURCES_STATIC_TEXT2' | globalTranslate
      }}</div>"
      class="label-section"
    >
      <select
        nhTranslate
        name="assetType"
        aria-required="true"
        [attr.aria-label]="
          ('OTHER_RESOURCES_STATIC_TEXT1' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('VEHICLE_STATIC_TEXT3' | globalTranslate)
        "
        [items]="tableCodeValue('OTHERRESTYPE', 'data.assetType')"
        formControlName="assetType"
      ></select>
    </nh-field>

    <div class="pt-1 hover-red">
      <a
        class="btn text-left ps-0 btn-link hover-red"
        role="button"
        tabindex="0"
        (click)="otherResourcesModal()"
      >
        <span style="padding-right: 8px">{{
          "OTHER_RESOURCES_STATIC_TEXT3" | globalTranslate
        }}</span>
        <span
          ><i
            class="fa fa-external-link"
            aria-hidden="true"
            aria-label="popup"
          ></i
        ></span>
      </a>
    </div>
    <br />
    @if (isEnabled('data.useDescription')) {
    <nh-field
      id="or_useDescription"
      label="{{ 'OTHER_RESOURCES_STATIC_TEXT4' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="assetType"
        [attr.aria-label]="'OTHER_RESOURCES_STATIC_TEXT4' | globalTranslate"
        [items]="tableCodeValue('OTHERRESOURCEUSE', 'data.useDescription')"
        formControlName="useDescription"
        aria-required="true"
      ></select>
    </nh-field>
    } @if (this.translatedLang === 'en') {
    <div>
      <nh-field
        id="or_assetAmount"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="{{ 'OTHER_RESOURCES_HOW_MUCH_IS' | globalTranslate }} {{
          selectedIndividual | fullname
        }}{{ 'APOSTROPHE_S' | globalTranslate }} {{
          getValue('data.assetType').value | globalTranslate
        }} {{ 'OTHER_RESOURCES_WORTH' | globalTranslate }}"
        class="label-section"
      >
        <nh-input-group prepend="$">
          <input
            nh
            type="decimal"
            maxlength="7"
            name="assetAmount"
            [attr.aria-label]="
              ('OTHER_RESOURCES_HOW_MUCH_IS' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ('APOSTROPHE_S' | globalTranslate) +
              ' ' +
              getValue('data.assetType').value +
              ' ' +
              ('OTHER_RESOURCES_WORTH' | globalTranslate)
            "
            formControlName="assetAmount"
            class="form-control"
          />
        </nh-input-group>
      </nh-field>
    </div>
    } @if (this.translatedLang !== 'en') {
    <div>
      <nh-field
        id="or_assetAmount"
        [mandatory]="false"
        [attr.aria-required]="false"
        label="¿Cuál es el valor de {{ getValue('data.assetType').value }} de {{
          selectedIndividual | fullname
        }}?"
        class="label-section"
      >
        <nh-input-group prepend="$">
          <input
            nh
            type="decimal"
            maxlength="7"
            name="assetAmount"
            formControlName="assetAmount"
            class="form-control"
          />
        </nh-input-group>
      </nh-field>
    </div>
    }

    <nh-field
      id="or_owedAmount"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'OTHER_RESOURCES_STATIC_TEXT5' | globalTranslate }} {{
        getValue('data.assetType').value | globalTranslate
      }}?"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          type="text"
          name="owedAmount"
          formControlName="owedAmount"
          class="form-control"
          [attr.aria-label]="
            ('OTHER_RESOURCES_STATIC_TEXT5' | globalTranslate) +
            ' ' +
            (getValue('data.assetType').value | globalTranslate)
          "
          placeholder="0.00"
          appTwoDigitDecimaNumber
          thousandSeparator=""
        />
      </nh-input-group>
    </nh-field>

    <br />
    @if (selectedIndividual) {
    <div>
      <h2 class="section-header">{{ "CO-OWENERS_TITLE" | globalTranslate }}</h2>
      <hr />
      <nh-field
        id="or_jointOwnership"
        label="{{ 'VEHICLE_STATIC_TEXT18' | globalTranslate }} {{
          getValue('data.assetType').value | globalTranslate
        }} {{ 'VEHICLE_STATIC_TEXT15' | globalTranslate }} {{
          selectedIndividual | fullname
        }}? <div class=hint>{{ 'VEHICLE_STATIC_TEXT16' | globalTranslate }} {{
          selectedIndividual | fullname
        }} {{ 'VEHICLE_STATIC_TEXT17' | globalTranslate }}</div>"
        class="label-section"
      >
        <select
          nhTranslate
          name="jointOwnership"
          [attr.aria-label]="
            ('VEHICLE_STATIC_TEXT18' | globalTranslate) +
            ' ' +
            (getValue('data.assetType').value | globalTranslate) +
            ('VEHICLE_STATIC_TEXT15' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname)
          "
          [items]="tableCodeValue('YESNO', 'data.jointOwnership')"
          formControlName="jointOwnership"
          aria-required="true"
        ></select>
      </nh-field>
      @if (isY('data.jointOwnership')) {
      <div>
        <nh-co-owner
          [jointOwnershipInformation]="
            getControl('data.jointOwnershipInformation')
          "
          [formData]="getControl('data')"
          [addRowValid]="checkValid()"
          [coOwnerIndividuals]="coOwnerIndividuals"
          [coOwnerIndivErrorMessage]="coOwnerIndivErrorMessage"
          [error]="error"
          (emitValidate)="coOwnerValidate($event)"
          (errorMessage)="getErrorMessage($event)"
          (removeRow)="removeRow($event)"
          (addRow)="addRow()"
        ></nh-co-owner>
      </div>
      }
    </div>
    }
  </section>
</nh-form>